import { Component } from '@angular/core';
import { TeamsCallQueuesContext } from '../../../../teams-call-queues/teams-call-queues.context';

@Component({
  selector: 'ziro-microsoft360-call-queue',
  template: '<router-outlet></router-outlet>',
  standalone: false,
  providers: [TeamsCallQueuesContext],
})
export class Microsoft360CallQueueComponent {}
